import Vue from 'vue';
import Dropdown from 'primevue/dropdown';

Vue.component('Dropdown', Dropdown);
